import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-820d42b0")

_pushScopeId("data-v-820d42b0")
const _hoisted_1 = { style: {"text-align":"center"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_register = _resolveComponent("register")!
  const _component_login = _resolveComponent("login")!
  const _component_reset_pw_reset_token = _resolveComponent("reset-pw-reset-token")!
  const _component_reset_pw = _resolveComponent("reset-pw")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('app_name')), 1),
    (_ctx.view === 'register')
      ? (_openBlock(), _createBlock(_component_register, {
          key: 0,
          onLogin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.view = 'login'))
        }))
      : (_ctx.view === 'login')
        ? (_openBlock(), _createBlock(_component_login, {
            key: 1,
            onResetPw: _cache[2] || (_cache[2] = ($event: any) => (_ctx.view = 'reset')),
            onRegister: _cache[3] || (_cache[3] = ($event: any) => (_ctx.view = 'register'))
          }))
        : (_ctx.view === 'resetPwResetToken')
          ? (_openBlock(), _createBlock(_component_reset_pw_reset_token, {
              key: 2,
              onLogin: _cache[4] || (_cache[4] = ($event: any) => (_ctx.view = 'login'))
            }))
          : (_openBlock(), _createBlock(_component_reset_pw, {
              key: 3,
              onLogin: _cache[5] || (_cache[5] = ($event: any) => (_ctx.view = 'login')),
              onResetPwResetToken: _cache[6] || (_cache[6] = ($event: any) => (_ctx.view = 'resetPwResetToken'))
            }))
  ]))
})